import { render, staticRenderFns } from "./LotteryItem.vue?vue&type=template&id=66c141b8&"
import script from "./LotteryItem.vue?vue&type=script&lang=ts&"
export * from "./LotteryItem.vue?vue&type=script&lang=ts&"
import style0 from "./LotteryItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LotteryItem.vue"
export default component.exports